goog.provide("shadow.js.shim.module$$mui$material$OutlinedInput");
goog.provide("module$shadow_js_shim_module$$mui$material$OutlinedInput");
shadow.js.shim.module$$mui$material$OutlinedInput = shadow.js.nativeProvides["@mui/material/OutlinedInput"] = shadow$bridge("@mui/material/OutlinedInput");
module$shadow_js_shim_module$$mui$material$OutlinedInput.default = shadow.js.shim.module$$mui$material$OutlinedInput;
